export default __webpack_public_path__ + "static/media/MLSA.a3e20df1.jpg";